export default function UserViewDetailsEditController(
  $scope,
  $state,
  $stateParams,
  $rootScope,
  usersService,
  RoleService,
  securityGroupsService,
  $q,
  gettextCatalog,
  languagesService,
) {
  'ngInject';

  //scope variables
  $scope.userId = $stateParams.userId;
  $scope.changes = [
    { op: 'add', roles: [] },
    { op: 'remove', roles: [] },
  ];
  $scope.loading = true;
  $scope.roles = [];
  $scope.existingRoles = [];
  $scope.selectedUser = {};
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.successFlag = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.sending = false;
  $scope.key = $stateParams.key;
  $scope.setAll = {};
  var currentUser = $rootScope.currentUser;
  $scope.isSelf = false;
  $scope.roleCount = 0;
  $scope.groupCount = 0;
  $scope.editedUserClaim = {};

  $scope.prefixOP = [
    { lookupCode: 'Mr', description: 'Mr.' },
    { lookupCode: 'Ms', description: 'Ms.' },
    { lookupCode: 'Dr', description: 'Dr.' },
    { lookupCode: 'Mrs', description: 'Mrs.' },
  ];

  $scope.measureUnitOptions = [
    { option: 'metric', des: 'Metric' },
    { option: 'imperial', des: 'Imperial' },
    { option: 'none', des: 'None' },
  ];

  $scope.languageOptions = languagesService.getSupportedLanguages();

  // function return true if string empty or has value
  var isStringOrEmpty = function (inputstring) {
    return !!inputstring || inputstring == '' ? true : false;
  };

  //Returns a promise when all fields have been updated asyncly
  var save = function () {
    $scope.resetFlags();
    $scope.sending = true;

    // Handle patch operation for each claim.
    var changeSets = [];
    if ($scope.editedUserClaim.firstName || $scope.editedUserClaim.firstName === '') {
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.firstName) ? 'update' : 'add',
        claims: { firstName: $scope.editedUserClaim.firstName },
      });
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.given_name) ? 'update' : 'add',
        claims: { given_name: $scope.editedUserClaim.firstName },
      });
    } else if ($scope.user.claims.data.firstName) {
      changeSets.push({ op: 'remove', claims: { firstName: $scope.user.claims.data.firstName } });
      changeSets.push({ op: 'remove', claims: { given_name: $scope.user.claims.data.given_name } });
    }
    if ($scope.editedUserClaim.lastName || $scope.editedUserClaim.lastName === '') {
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.lastName) ? 'update' : 'add',
        claims: { lastName: $scope.editedUserClaim.lastName },
      });
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.family_name) ? 'update' : 'add',
        claims: { family_name: $scope.editedUserClaim.lastName },
      });
    } else if ($scope.user.claims.data.lastName) {
      changeSets.push({ op: 'remove', claims: { lastName: $scope.user.claims.data.lastName } });
      changeSets.push({
        op: 'remove',
        claims: { family_name: $scope.user.claims.data.family_name },
      });
    }

    if (
      $scope.editedUserClaim.firstName ||
      $scope.editedUserClaim.lastName ||
      $scope.editedUserClaim.firstName === '' ||
      $scope.editedUserClaim.lastName === ''
    ) {
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.name) ? 'update' : 'add',
        claims: {
          name: (
            ($scope.editedUserClaim.firstName ? $scope.editedUserClaim.firstName : '') +
            ' ' +
            ($scope.editedUserClaim.lastName ? $scope.editedUserClaim.lastName : '')
          ).trim(),
        },
      });
    } else if ($scope.user.claims.data.firstName || $scope.user.claims.data.lastName) {
      changeSets.push({ op: 'remove', claims: { name: $scope.user.claims.data.name } });
    }

    if ($scope.editedUserClaim.phoneNumber || $scope.user.claims.data.phoneNumber)
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.phoneNumber) ? 'update' : 'add',
        claims: { phoneNumber: $scope.editedUserClaim.phoneNumber },
      });
    if ($scope.editedUserClaim.unitOfMeasure || $scope.user.claims.data.unitOfMeasure)
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.unitOfMeasure) ? 'update' : 'add',
        claims: { unitOfMeasure: $scope.editedUserClaim.unitOfMeasure },
      });
    if ($scope.editedUserClaim.timezone || $scope.user.claims.data.timezone)
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.timezone) ? 'update' : 'add',
        claims: { timezone: $scope.editedUserClaim.timezone },
      });
    if ($scope.editedUserClaim.language || $scope.user.claims.data.language)
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.language) ? 'update' : 'add',
        claims: { language: $scope.editedUserClaim.language },
      });
    if ($scope.editedUserClaim.prefix || $scope.user.claims.data.prefix)
      changeSets.push({
        op: isStringOrEmpty($scope.user.claims.data.prefix) ? 'update' : 'add',
        claims: { prefix: $scope.editedUserClaim.prefix || '' },
      }); // no null prefix

    var defer = $q.defer();

    //Returns a promise to update a security group
    function updateSecurityGroup(group) {
      var alreadyExists = false; //Make sure that we don't update something hasn't been updateed
      var def = $q.defer();

      for (var x = 0; x < $scope.user.groups.data.length; x++) {
        if ($scope.user.groups.data[x].id === group.id) {
          alreadyExists = true;
          break;
        }
      } //end for

      //Return either a patch or a remove request based on the change
      if (group._selected && !alreadyExists) {
        var data = [
          { op: 'add', value: { user: securityGroupsService.getUserUrl() + $scope.user.id } },
        ];
        return securityGroupsService.patchEquipmentUserUpdate(group.id, data);
      } //inner if
      else if (!group._selected && alreadyExists) {
        //remove
        var data = [
          { op: 'remove', value: { user: securityGroupsService.getUserUrl() + $scope.user.id } },
        ];
        return securityGroupsService.patchEquipmentUserUpdate(group.id, data);
      } //else

      //no changes do not need to call API
      def.resolve(gettextCatalog.getString('Not necessary'));

      return def.promise;
    }

    var index = 0;
    //Recursive functino to update security groups
    function updateSecurityGroupsFn(index, defer) {
      if (!$scope.groups) {
        defer.resolve(gettextCatalog.getString('Not necessary'));
      }
      if (index < $scope.groups.length) {
        updateSecurityGroup($scope.groups[index]).then(
          function (response) {
            updateSecurityGroupsFn(++index, defer);
          },
          function (error) {
            defer.reject(error);
            //error updating the security group
          },
        );
      } else {
        defer.resolve(gettextCatalog.getString('Success'));
      }
    }

    var currentGroupIndex = 0;

    usersService
      .patchUserInfo($stateParams.userId, changeSets)
      .then(
        function (response) {
          for (var i = 0; i < $scope.roles.length; i++) {
            if ($scope.roles[i]._selected) {
              $scope.applyChange({ op: 'add', id: $scope.roles[i].id.toString() });
            } else if (!$scope.roles[i]._selected) {
              $scope.applyChange({ op: 'remove', id: $scope.roles[i].id.toString() });
            }
          }

          return usersService
            .patchUserRoles($stateParams.userId, $scope.changes)
            .then(null, function (error) {
              $scope.editing = false;
              $scope.sending = false;
              var errorMsg = gettextCatalog.getString(
                'An error occurred while updating user roles',
              );
              if (error.data || error.status) {
                if (error.data.message) {
                  errorMsg =
                    error.data.message +
                    ' ' +
                    (error.status.toString() + ' - ' + error.statusText.toString());
                } else {
                  errorMsg +=
                    ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
                }
              } else {
                errorMsg += gettextCatalog.getString('. Please try again later.');
              }
              defer.reject(errorMsg);
            });
        },
        function (error) {
          $scope.editing = false;
          $scope.sending = false;
          var errorMsg = gettextCatalog.getString(
            'An error occurred while updating user information',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }

          defer.reject(errorMsg);
        },
      )
      .then(function (response) {
        var def = $q.defer();
        //check security groups.
        updateSecurityGroupsFn(0, def);
        return def.promise.then(null, function (error) {
          $scope.editing = false;
          $scope.sending = false;
          var errorMsg = gettextCatalog.getString(
            "An error occurred while updating user's security groups",
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          defer.reject(errorMsg);
        });
      })
      .then(function (response) {
        defer.resolve(gettextCatalog.getString('User updated successfully.'));
      })
      .finally(function () {
        $scope.editing = false;
        $scope.sending = false;
      });

    return defer.promise;
  };

  $scope.prefixChanges = function () {
    window.dataLayer.push({
      event: 'userPrefixChanged',
      data: {
        prefix: $scope.editedUserClaim.prefix,
      },
    });
  };

  $scope.firstNameChanged = _.debounce(function () {
    window.dataLayer.push({
      event: 'userFirstNameChanged',
    });
  }, 1000);

  $scope.lastNameChanged = _.debounce(function () {
    window.dataLayer.push({
      event: 'userLastNameChanged',
    });
  }, 1000);

  $scope.phoneNumberChanged = _.debounce(function () {
    window.dataLayer.push({
      event: 'userPhoneNumberChanged',
    });
  }, 1000);

  $scope.unitOfMeasureChanged = function () {
    window.dataLayer.push({
      event: 'userUnitOfMeasureChanged',
      data: {
        unitOfMeasure: $scope.editedUserClaim.unitOfMeasure,
      },
    });
  };

  $scope.saveButtonPressed = function () {
    if (
      $scope.sending ||
      $scope.roleCount == 0 ||
      ($scope.groupsRequired && $scope.groupCount == 0) ||
      $scope.editUserForm.$invalid
    ) {
      return;
    }
    //wait for all promises to finish and return to detail page if finished
    save().then(
      function (response) {
        $scope.sending = false;
        $state.go('admin.userdetails', { userId: $scope.userId, success: true });
      },
      function (errorMsg) {
        $scope.sending = false;
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        console.log('Failed to save');
      },
    );
  };

  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  //Scope functions
  var refresh = function () {
    if (currentUser.id === $stateParams.userId) {
      $scope.onLoadErrorText = gettextCatalog.getString(
        'Cannot change your own permissions. To change your name and personal info, navigate to your profile page.',
      );
      $scope.onLoadErrorFlag = true;
      $scope.loading = false;
      return;
    }
    usersService
      .getUser($stateParams.userId)
      .then(
        function (response) {
          $scope.user = response.data;
          $scope.$emit('$viewContentLoaded');

          if (!$state.current.ncyBreadcrumbLabel) {
            $state.current.ncyBreadcrumbLabel = $scope.user.name;
          }
          $scope.editedUserClaim = angular.copy($scope.user.claims.data);

          return RoleService.getRoles(null, function (error) {
            $scope.loading = false;
            $scope.user = null;
            if (!$state.current.ncyBreadcrumbLabel) {
              if ($scope.$parent.selectedName) {
                $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
              } else {
                $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Error');
              }
            }
            var errorMsg = gettextCatalog.getString(
              'An error occurred while retrieving user role information',
            );
            if (error.data || error.status) {
              if (error.data.message) {
                errorMsg =
                  error.data.message +
                  ' ' +
                  (error.status.toString() + ' - ' + error.statusText.toString());
              } else {
                errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
              }
            } else {
              errorMsg += gettextCatalog.getString('. Please try again later.');
            }
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
          });
        },
        function (error) {
          $scope.loading = false;
          $scope.user = null;
          if (!$state.current.ncyBreadcrumbLabel) {
            if ($scope.$parent.selectedName) {
              $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
            } else {
              $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Error');
            }
          }
          var errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving user information',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.onLoadErrorFlag = true;
          $scope.onLoadErrorText = errorMsg;
        },
      )
      .then(function (response) {
        $scope.existingRoles = $scope.user.roles.data;
        $scope.roles = response.data;

        for (var i = 0; i < $scope.existingRoles.length; i++) {
          for (var j = 0; j < $scope.roles.length; j++) {
            if ($scope.roles[j].id === $scope.existingRoles[i].id) {
              $scope.roles[j]._selected = true;
              $scope.roleCount++;
              continue;
            }
          }
        }
        if ($scope.roleCount === $scope.roles.length) {
          $scope.setAll.roles = true;
        }

        if (currentUser.account.securityMode !== 'Open') {
          securityGroupsService.getAllSecurityGroups().then(
            function (response) {
              $scope.groups = response.data.data;

              if ($scope.user.groups) {
                for (var i = 0; i < $scope.user.groups.data.length; i++) {
                  for (var j = 0; j < $scope.groups.length; j++) {
                    if ($scope.groups[j].id === $scope.user.groups.data[i].id) {
                      $scope.groups[j]._selected = true;
                      $scope.groupCount++;
                      continue;
                    }
                  }
                }

                if ($scope.groupCount === $scope.groups.length) {
                  $scope.setAll.groups = true;
                }
              }
              $scope.loading = false;
              if (currentUser.securityMode !== 'Open') {
                $scope.groupsRequired = true;
              }
            },
            function (error) {
              $scope.loading = false;
              $scope.user = null;
              if (!$state.current.ncyBreadcrumbLabel) {
                if ($scope.$parent.selectedName) {
                  $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
                } else {
                  $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Error');
                }
              }
              var errorMsg = gettextCatalog.getString(
                'An error occurred while retrieving security groups',
              );
              if (error.data || error.status) {
                if (error.data.message) {
                  errorMsg =
                    error.data.message +
                    ' ' +
                    (error.status.toString() + ' - ' + error.statusText.toString());
                } else {
                  errorMsg +=
                    ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
                }
              } else {
                errorMsg += gettextCatalog.getString('. Please try again later.');
              }
              $scope.onLoadErrorFlag = true;
              $scope.onLoadErrorText = errorMsg;
            },
          );
        } else {
          $scope.loading = false;
        }
      });
  };

  if (currentUser) {
    refresh();
  }

  $rootScope.$watch('currentUser', function (newVal, oldVal) {
    if (newVal && !oldVal) {
      currentUser = $rootScope.currentUser;
      refresh();
    }
  });

  $scope.roleSelected = function (role, selectingAll = false) {
    if (role._selected) {
      $scope.roleCount++;
      if ($scope.roleCount == $scope.roles.length) {
        $scope.setAll.roles = true;
      }
    } else {
      $scope.roleCount--;
      if ($scope.roleCount == 0 || $scope.roleCount < $scope.roles.length) {
        $scope.setAll.roles = false;
      }
    }
    if (!selectingAll) {
      GTM_RoleChanges(role._selected ? 'userRoleSelected' : 'userRoleDeselected');
    }
  };

  $scope.groupSelected = function (group, selectingAll) {
    if (group._selected) {
      $scope.groupCount++;
      if ($scope.groupCount == $scope.groups.length) {
        $scope.setAll.groups = true;
      }
    } else {
      $scope.groupCount--;
      if ($scope.groupCount == 0 || $scope.groupCount < $scope.groups.length) {
        $scope.setAll.groups = false;
      }
    }
    if (!selectingAll) {
      GTM_GroupChanges(
        group._selected ? 'userSecurityGroupSelected' : 'userSecurityGroupDeselected',
      );
    }
  };

  $scope.checkAllRoles = function () {
    for (var i = 0; i < $scope.roles.length; i++) {
      if ($scope.roles[i]._selected == $scope.setAll.roles) {
        continue;
      }
      $scope.roles[i]._selected = $scope.setAll.roles;
      $scope.roleSelected($scope.roles[i], true);
    }
    GTM_RoleChanges($scope.setAll.roles ? 'userRolesAllSelected' : 'userRolesAllDeselected');
  };

  $scope.checkAllGroups = function () {
    for (var i = 0; i < $scope.groups.length; i++) {
      if ($scope.groups[i]._selected == $scope.setAll.groups) {
        continue;
      }
      $scope.groups[i]._selected = $scope.setAll.groups;
      $scope.groupSelected($scope.groups[i], true);
    }
    GTM_GroupChanges(
      $scope.setAll.groups ? 'userSecurityGroupsAllSelected' : 'userSecurityGroupsAllDeselected',
    );
  };

  $scope.applyChange = function (newChange) {
    for (var i = 0; i < $scope.changes.length; i++) {
      for (var j = 0; j < $scope.changes[i].roles.length; j++) {
        if ($scope.changes[i].roles[j].id === newChange.id) {
          if ($scope.changes[i].op === newChange.op) {
            return;
          } else {
            $scope.changes[i].roles.splice(j, 1);
            return;
          }
        }
      }
    }

    if (newChange.op === 'add') {
      //don't attempt to add a role that the user already has
      for (var i = 0; i < $scope.existingRoles.length; i++) {
        if ($scope.existingRoles[i].id === newChange.id) {
          return;
        }
      }
    }

    if (newChange.op === 'remove') {
      for (var i = 0; i < $scope.existingRoles.length; i++) {
        if ($scope.existingRoles[i].id === newChange.id) {
          break;
        }
      }
    }

    for (var i = 0; i < $scope.changes.length; i++) {
      if ($scope.changes[i].op === newChange.op) {
        $scope.changes[i].roles.push({ id: newChange.id });
        return;
      }
    }
  };

  function GTM_RoleChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.roles.length,
        totalSelected: $scope.roleCount,
      },
    });
  }

  function GTM_GroupChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.groups.length,
        totalSelected: $scope.groupCount,
      },
    });
  }
}
